import { StyleSheet } from '@react-pdf/renderer';

import { COLORS } from '@/shared/constants/colors';

export const styles = StyleSheet.create({
  page: {
    padding: '90px 21px 220px 23px',
    backgroundColor: COLORS.white,
  },
  border: {
    border: `1px solid ${COLORS.systemDark300}`,
    position: 'absolute',
    width: 794 - 66,
    height: 1056 - 180 - 47,
    left: 33,
    right: 33,
    top: 33,
    borderBottom: 0,
  },
  footer: {
    fontSize: 13,
    textAlign: 'center',
    position: 'absolute',
    bottom: 33 + 18,
    left: 33,
    right: 33,
    width: 794 - 66,
    border: `1px solid ${COLORS.systemDark300}`,
    paddingBottom: 33,
    paddingLeft: 33,
    borderTop: 0,
  },
  footerFirst: {
    height: 247,
    justifyContent: 'flex-end',
    bottom: 33 + 18,
  },
  section: {
    padding: 33,
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    lineHeight: 1.2,
  },
  header: {
    fontSize: '12.75px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 34,
    top: 16,
    position: 'absolute',
    width: 794 - 50,
  },
  main: {
    height: '100%',
    padding: '24px 0 16px',
    fontSize: 14,
  },
  watermark: {
    opacity: '0.06',
    position: 'absolute',
    top: '400px',
    left: '0',
    right: '0',
    textAlign: 'center',
    fontSize: 34,
    transform: 'rotate(-45deg)',
  },
  placeholder: {
    color: COLORS.systemDark100,
  },
  title: {
    fontSize: 34,
    paddingBottom: 16,
    textAlign: 'center',
    fontWeight: 700,
    lineHeight: 1,
    paddingTop: 4,
  },
  center: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  footerColumns: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    padding: '0 40px 16px',
  },
  footerColumn: {
    width: '100%',
    textAlign: 'left',
    flexDirection: 'column',
    gap: 10,
  },
  blockTitle: {
    fontSize: 19,
    fontWeight: 700,
    textTransform: 'uppercase',
    paddingTop: 10,
    position: 'relative',
    left: -30,
    height: 40,
  },
  mainPadding: {
    padding: '16px 40px',
    gap: 8,
  },
  listNumber: {
    width: '36px',
    fontWeight: 400,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 0,
    flexShrink: 0,
  },
  testatorInfoRow: {
    width: 560,
  },
  beneficiaryInfoRow: {
    width: 530,
  },
  subTitle: {
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  table: {
    flexDirection: 'column',
    margin: '24px -24px 0 -24px',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    flexBasis: '18%',
    border: `1px solid ${COLORS.systemDark200}`,
    margin: '-1px -1px 0 0 ',
    height: '100%',
    padding: 4,
  },
  tableCellWide: {
    flexBasis: '21%',
  },
  tableCol: {
    flexDirection: 'column',
  },
  line: {
    borderBottom: `1px solid ${COLORS.systemDark300}`,
    width: 200,
    height: 24,
  },
  listItem: {
    gap: 8,
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
  },
  listText: {
    width: 580,
    marginBottom: 2,
  },
  checkmark: {
    fontFamily: 'NotoSansKo',
  },
  beneficiaryBlock: {
    flexDirection: 'column',
    gap: 6,
  },
  messageWrapper: {
    fontSize: 14,
    padding: '0 40px',
    gap: 4,
  },
  poweredByText: {
    position: 'absolute',
    bottom: -16 - 8,
    left: 0,
    width: '100%',
    textAlign: 'center',
  },
});
